import { chipClasses, lighten } from "@mui/material";
function createChipFilledOutlineVariantStyles() {
  const colors = ["default", "primary", "secondary", "error", "warning", "success", "info"];
  return colors.flatMap((color) => {
    return [
      {
        props: { variant: "filledOutline", color, disabled: false },
        style: ({ theme }) => {
          switch (color) {
            case "secondary": {
              const borderColor = theme.vars.palette.secondary.main;
              const deleteIconColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.54)`;
              const deleteIconHoverColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.87)`;
              return {
                color: theme.vars.palette.text.primary,
                border: `1px solid ${borderColor}`,
                backgroundColor: theme.vars.palette.secondary.light,
                [`& .${chipClasses.icon}`]: {
                  color: theme.vars.palette.action.active
                },
                [`& .${chipClasses.deleteIcon}`]: {
                  color: deleteIconColor
                },
                [`& .${chipClasses.deleteIcon}:hover`]: {
                  color: deleteIconHoverColor
                },
                [`& .${chipClasses.avatar}`]: {
                  color: theme.vars.palette.text.primary,
                  backgroundColor: theme.vars.palette.common.white
                }
              };
            }
            case "default":
            case void 0: {
              const borderColor = theme.vars.palette.action.active;
              const deleteIconColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.54)`;
              const deleteIconHoverColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.87)`;
              return {
                color: theme.vars.palette.text.primary,
                border: `1px solid ${borderColor}`,
                backgroundColor: theme.vars.palette.action.selected,
                [`& .${chipClasses.icon}`]: {
                  color: theme.vars.palette.action.active
                },
                [`& .${chipClasses.deleteIcon}`]: {
                  color: deleteIconColor
                },
                [`& .${chipClasses.deleteIcon}:hover`]: {
                  color: deleteIconHoverColor
                },
                [`& .${chipClasses.avatar}`]: {
                  color: theme.vars.palette.text.primary,
                  backgroundColor: theme.vars.palette.common.white
                }
              };
            }
            default: {
              const borderColor = theme.vars.palette[color].main;
              const deleteIconColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.54)`;
              const deleteIconHoverColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.87)`;
              return {
                color: theme.vars.palette.text.primary,
                border: `1px solid ${borderColor}`,
                backgroundColor: lighten(theme.palette[color].main, 0.8),
                [`& .${chipClasses.icon}`]: {
                  color: theme.vars.palette.action.active
                },
                [`& .${chipClasses.deleteIcon}`]: {
                  color: deleteIconColor
                },
                [`& .${chipClasses.deleteIcon}:hover`]: {
                  color: deleteIconHoverColor
                },
                [`& .${chipClasses.avatar}`]: {
                  color: theme.vars.palette.text.primary,
                  backgroundColor: theme.vars.palette.common.white
                }
              };
            }
          }
        }
      },
      {
        // disabled style is always the same
        props: { variant: "filledOutline", color, disabled: true },
        style: ({ theme }) => ({
          color: theme.vars.palette.text.disabled,
          borderColor: theme.vars.palette.action.disabled,
          backgroundColor: theme.vars.palette.action.disabledBackground
        })
      }
    ];
  });
}
export {
  createChipFilledOutlineVariantStyles
};
//# sourceMappingURL=chip.js.map
